export const GET_GRN_REPORT_REQUEST = "GET_GRN_REPORT_REQUEST";
export const GET_GRN_REPORT_SUCCESS = "GET_GRN_REPORT_SUCCESS";
export const GET_GRN_REPORT_FAILURE = "GET_GRN_REPORT_FAILURE";

export const GET_GRN_REPORT_DOWNLOAD_REQUEST = "GET_GRN_REPORT_DOWNLOAD_REQUEST";
export const GET_GRN_REPORT_DOWNLOAD_SUCCESS = "GET_GRN_REPORT_DOWNLOAD_SUCCESS";
export const GET_GRN_REPORT_DOWNLOAD_FAILURE = "GET_GRN_REPORT_DOWNLOAD_FAILURE";
